import {
  MealDetailsConnectorApollo,
  TrackerAddMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  useAppContext,
  // useTimestamp,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import TrackerAddMealContainer from './TrackerAddMealContainer';

const TrackerIndexPage = () => {
  const { dietMealId, mealType, userDietSetId } = useParams();
  const { post } = useAppContext();
  // const { timestamp1 } = useTimestamp();

  if (!dietMealId || !mealType || !userDietSetId) {
    return <div>Missing parameters</div>;
  }

  return (
    <MealDetailsConnectorApollo
      userDietSetId={+userDietSetId}
      mealType={+mealType}
      dietMealId={+dietMealId}
    >
      {({ ...mealData }) => (
        <TrackerAddMealConnectorApollo post={post}>
          {({ addMeal }: { addMeal: (input: any, saveYourMeal: boolean) => Promise<any> }) => (
            <SaveAsUserMealConnectorApollo post={post}>
              {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
                <TrackerAddMealContainer
                  {...mealData.meal}
                  loading={mealData.loading}
                  addMeal={addMeal}
                  saveAsUserMeal={saveAsUserMeal}
                  key={dietMealId}
                />
              )}
            </SaveAsUserMealConnectorApollo>
          )}
        </TrackerAddMealConnectorApollo>
      )}
    </MealDetailsConnectorApollo>
  );
};

export default TrackerIndexPage;
